/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type CartItemImage_item$ref = any;
export type CartItemImage_item = {
    readonly firstPhotoWebPath: string | null;
    readonly pdpURL: string | null;
    readonly title: string | null;
    readonly " $refType": CartItemImage_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartItemImage_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "firstPhotoWebPath",
            "args": [
                {
                    "kind": "Literal",
                    "name": "size",
                    "value": "large"
                }
            ],
            "storageKey": "firstPhotoWebPath(size:\"large\")"
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "pdpURL",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = 'd8e0cce9a8d4f4a9d0906c11cbd4ea56';
export default node;
